// simple version lodash debounce function
export default class FuncHelper {
  static debounce(callback, delay) {
    let timer;
    return (...args) => {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        callback(...args);
      }, delay);
    };
  }
}
